import ResultItem from './resultItem';
export default ResultItem;
